<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    offset-y
    min-width="320"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        x-small
        class="ml-1"
        :color="valore ? 'amber darken-2' : 'grey lighten-1'"
        v-on="on"
        @click.stop
      >
        <v-icon small>
          {{ valore ? "mdi-note-text" : "mdi-note-plus-outline" }}
        </v-icon>
      </v-btn>
    </template>

    <v-card width="320">
      <v-card-text class="pb-0">
        <v-textarea
          ref="campo"
          v-model="bozza"
          label="Nota"
          rows="3"
          auto-grow
          outlined
          dense
          hide-details
          @keydown.esc="annulla"
          @keydown.enter.exact.prevent="salva"
        />
        <div class="text-caption grey--text mt-1">
          Invio per salvare, Esc per annullare
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn
          v-if="valore"
          text
          small
          color="red"
          @click="cancella"
        >
          Elimina
        </v-btn>
        <v-spacer />
        <v-btn text small color="grey" @click="annulla">Annulla</v-btn>
        <v-btn text small color="green" @click="salva">Salva</v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
/**
 * Nota di un singolo colore.
 *
 * Il salvataggio è esplicito, non a debounce: una nota è testo discorsivo, e
 * spedirla mentre la si scrive riempirebbe il buffer di versioni intermedie.
 */
export default {
  props: {
    valore: { type: String, default: null },
  },

  data() {
    return {
      menu: false,
      bozza: "",
    };
  },

  watch: {
    menu(aperto) {
      if (!aperto) return;
      this.bozza = this.valore || "";
      this.$nextTick(() => {
        const campo = this.$refs.campo;
        if (campo) campo.focus();
      });
    },
  },

  methods: {
    salva() {
      const testo = this.bozza.trim();
      if (testo !== (this.valore || "")) this.$emit("salva", testo);
      this.menu = false;
    },

    cancella() {
      this.$emit("salva", "");
      this.menu = false;
    },

    annulla() {
      this.menu = false;
    },
  },
};
</script>
